<template>
  <div>
    <LayoutBasic :showLinksMenu="false">
      <template v-slot:title>
        <v-list-item @click="$router.push('/')" class="hoverable">
          <v-list-item-icon>
            <v-icon large>mdi-view-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="title font-weight-bold">Inicio</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </template>

      <template v-slot:navigation-title>Producción</template>

      <template v-slot:navigation-after-links>
        <div class="px-3 mb-3">
          <v-chip
            small
            :color="sucursalActiva ? 'deep-purple darken-2' : 'grey darken-2'"
            dark
            class="cursor-pointer"
            style="cursor: pointer; width: 100%"
            @click="dialogSucursal = true"
          >
            <v-icon x-small left>mdi-store</v-icon>
            <span class="text-truncate">{{ sucursalActiva ? sucursalActiva.nombre : 'Elegir sucursal' }}</span>
            <v-spacer />
            <v-icon x-small right>mdi-swap-horizontal</v-icon>
          </v-chip>
        </div>

        <v-list dense nav>
          <v-list-item v-if="!esOperario" :to="{ name: 'empresa.produccion.home' }" exact class="hoverable">
            <v-list-item-icon><v-icon>mdi-view-dashboard-outline</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Tablero</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="{ name: 'empresa.produccion.cola' }" class="hoverable">
            <v-list-item-icon><v-icon>mdi-clipboard-play-outline</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Cola de producción</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="!esOperario" :to="{ name: 'empresa.produccion.plan' }" class="hoverable">
            <v-list-item-icon><v-icon>mdi-clipboard-list-outline</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Plan de producción</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="!esOperario" :to="{ name: 'empresa.produccion.orden.listado' }" class="hoverable">
            <v-list-item-icon><v-icon>mdi-factory</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Órdenes de producción</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="!esOperario" :to="{ name: 'empresa.produccion.receta.listado' }" class="hoverable">
            <v-list-item-icon><v-icon>mdi-clipboard-text-outline</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Recetas / Programas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="!esOperario" :to="{ name: 'empresa.produccion.maquina.listado' }" class="hoverable">
            <v-list-item-icon><v-icon>mdi-robot-industrial</v-icon></v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Máquinas</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>

      <template v-slot:vista-previa>
        <router-view v-if="sucursalActiva" />
        <div v-else class="d-flex flex-column align-center justify-center" style="height: 60vh">
          <v-icon size="64" color="grey darken-2" class="mb-4">mdi-store-off</v-icon>
          <p class="grey--text text--darken-1 subtitle-1">Seleccioná una sucursal para operar</p>
          <v-btn color="primary" @click="dialogSucursal = true">
            <v-icon left>mdi-store</v-icon>
            Elegir sucursal
          </v-btn>
        </div>
      </template>
    </LayoutBasic>

    <v-dialog v-model="dialogSucursal" max-width="420" :persistent="!sucursalActiva">
      <v-card>
        <v-card-title class="subtitle-1 font-weight-bold">
          <v-icon left>mdi-store</v-icon>
          Seleccionar sucursal
          <v-spacer />
          <v-btn v-if="sucursalActiva" icon small @click="dialogSucursal = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-2 pb-4">
          <p class="body-2 grey--text mb-4">
            La producción (stock, recetas y órdenes) opera en el contexto de una sucursal.
          </p>

          <v-progress-linear v-if="loadingSucursales" indeterminate color="primary" class="mb-3" />

          <v-list dense v-else>
            <v-list-item
              v-for="s in sucursales"
              :key="s.id"
              @click="seleccionarSucursal(s)"
              :class="sucursalActiva && sucursalActiva.uuid === s.uuid ? 'deep-purple darken-4 rounded' : 'hoverable'"
            >
              <v-list-item-icon>
                <v-icon :color="sucursalActiva && sucursalActiva.uuid === s.uuid ? 'deep-purple lighten-2' : ''">
                  mdi-store
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ s.nombre }}</v-list-item-title>
                <v-list-item-subtitle v-if="s.direccion">{{ s.direccion }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action v-if="sucursalActiva && sucursalActiva.uuid === s.uuid">
                <v-icon small color="deep-purple lighten-2">mdi-check-circle</v-icon>
              </v-list-item-action>
            </v-list-item>

            <v-list-item v-if="!loadingSucursales && sucursales.length === 0">
              <v-list-item-content>
                <v-list-item-title class="grey--text">No hay sucursales disponibles</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import LayoutBasic from '@/layouts/LayoutBasic.vue';

export default {
  name: 'ProduccionEmpresaLayout',
  components: { LayoutBasic },
  data() {
    return {
      dialogSucursal: false,
      sucursales: [],
      loadingSucursales: false,
      sucursalActiva: null,
    };
  },
  computed: {
    ...mapGetters('sucursales', ['sucursalUuid']),
    esOperario() {
      const role = (this.$store.state.auth.user && this.$store.state.auth.user.role) || [];
      return role.includes('produccion');
    },
  },
  methods: {
    ...mapMutations('sucursales', ['SET_SUCURSAL_UUID_COOKIE']),

    async fetchSucursales() {
      this.loadingSucursales = true;
      try {
        const res = await this.axios.get('/sucursales/sucursales');
        this.sucursales = res.data;

        if (this.sucursalUuid) {
          const match = this.sucursales.find(s => s.uuid === this.sucursalUuid);
          if (match) {
            this.sucursalActiva = match;
          } else {
            this.dialogSucursal = true;
          }
        } else {
          this.dialogSucursal = true;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingSucursales = false;
      }
    },

    seleccionarSucursal(sucursal) {
      this.SET_SUCURSAL_UUID_COOKIE(sucursal.uuid);
      this.sucursalActiva = sucursal;
      this.dialogSucursal = false;
    },
  },
  created() {
    this.fetchSucursales();
  },
};
</script>
